import { NavigationGuardNext, Route } from 'vue-router';
import Store from '@/Store';

export default function UserIsNotLoggedIn(to: Route, from: Route, next: NavigationGuardNext): void {
  if (Store.state.user.jwt) {
    next({ name: 'home' })
  } else {
    next()
  }
}
